import { useQueryParams } from "../../../../../../hooks/useQueryParams";
import { LIST_TYPES } from "../utils/listTypes";
import { STRINGS } from "../utils/strings";

import ButtonCounter from "./ButtonCounter";
import TextCounter from "./TextCounter";


const ScrollList = ({ array, type }) => {
  const { filters } = useQueryParams();

  // Check if a specific value is active based on URL parameters
  const isValueActive = (filterType, value) => {
    const filterValue = filters.get(filterType) || filters.get(filterType + "__in");
    if (!filterValue) {
      return false;
    }

    const selectedValues = filterValue.split(",").map((v) => v.trim());
    return selectedValues.includes(value);
  };

  const getComponent = (filterType, name, total, idx) => {
    const isActive = isValueActive(filterType, name);

    switch (type) {
      case LIST_TYPES.BUTTON_LIST:
        return (
          <ButtonCounter
            title={name}
            value={total}
            statusType={filterType}
            key={idx}
            isActive={isActive}
          />
        );
      case LIST_TYPES.TEXT_LIST:
        return <TextCounter title={name} value={total} key={idx} />;
      default:
        return <TextCounter title={name} value={total} key={idx} />;
    }
  };

  if (!array || array.length === 0) {
    return <div className="pt-2 text-[0.85rem]">{STRINGS.NO_ROLES_AVAILABLE}</div>;
  }

  return (
    <div className="grid grid-cols-2 gap-1 pr-3 overflow-y" data-testid="scroll-list">
      {array &&
        array.length > 0 &&
        array.map((item) => getComponent(item.field_name, item.label, item.total, item.key))}
    </div>
  );
};
export default ScrollList;
